export const config = {
	MAX_NUMBERS_CC_PAYMENT: 20,
	SHOW_TOP_UP: false,
};
